export const List = {
  V09: {
    name: "V09",
    price: "31.88",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_usp.webp",
        },
        desc: "Explore",
        url: "",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/V09/v09_spec.webp",
        },
        desc: "Specs",
        url: "./params-table-config.html?type=V09",
      },
    ],
  },
  A06: {
    name: "A06",
    price: "17.98",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_usp.webp",
        },
        desc: "Explore",
        url: "",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06/a06_spec.webp",
        },
        desc: "Specs",
        url: "./params-table-config.html?type=A06",
      },
    ],
  },
  Z03: {
    name: "Z03",
    price: "13.48",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_usp.webp",
        },
        desc: "Explore",
        url: "",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/Z03/z03_spec.webp",
        },
        desc: "Specs",
        url: "./params-table-config.html?type=Z03",
      },
    ],
  },
  // "007": {
  //   name: "007",
  //   price: "29.98",
  //   imgList: [
  //     {
  //       img: {
  //         pc:
  //           "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_usp.webp",
  //       },
  //       desc: "Explore",
  //       url: "",
  //     },
  //     {
  //       img: {
  //         pc:
  //           "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/007/007_spec.webp",
  //       },
  //       desc: "Specs",
  //       url: "./params-table-config.html?type=007",
  //     },
  //   ],
  // },
  A06PLUS: {
    name: "A06 PLUS",
    price: "13.98",
    imgList: [
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06PLUS/a06plus_usp.webp",
        },
        desc: "Explore",
        url: "",
      },
      {
        img: {
          pc:
            "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/HYCAN_%E5%AE%98%E7%BD%91/Navigation/Navi/A06PLUS/a06plus_spec.webp",
        },
        desc: "Specs",
        url: "./params-table-config.html?type=A06PLUS",
      },
    ],
  },
};

export const menuList = {
  user: {
    title: "我的账号",
    list: [
      {
        label: "我的订单",
        url: "./test-order.html",
      },
      {
        label: "退出登录",
        type: "loginOut",
      },
    ],
  },
  language: {
    title: "Language",
    list: [
      {
        label: "English",
        url: "./index.html",
      },
      {
        label: "中文",
        url: "../index.html",
      },
    ],
  },
};
